<template>
    <div class="discar modal-2" v-if='getModalCall'>
        <div class="modal-content-my">
            <form class='form-modal' v-on:submit.prevent="sendCall">
				<div class="modal-head">
					<h4 class="title-text">Discar</h4>
					<span @click='btnClose' class='closeBtn'>&times;</span>
				</div>
				<div class="row">
					<div class="col-md-9 form-group">
						<input id="phoneCall" class='esquerda form-control' type="text" placeholder="Telefone">
					</div>
					<div class="col-md-2 form-group">
						<button @click="sendCall" class="btn btn-success" type="button">Discar</button>
					</div>
				</div>
			</form>
		</div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
// const connection = io.connect(`${location.protocol}//${location.hostname}:3002/`);
const connection = { 'on': function() {}, 'emit': function() {} };

export default {
    computed:{
        ...mapGetters([
				'getModalCall',
				'getChannel',
				'getExtension'
			])
    },
    methods:{
        ...mapActions([
				'settModalCall',
				'setChannel',
				'setExtension'
			]),
			btnClose(event){
				this.settModalCall();
			},
			sendCall(){
				var phone = document.getElementById('phoneCall').value;
				connection.emit('Originate', {
					calltype: 'outgoing',
					extension: this.getExtension(),
					phone: phone
				});
				this.settModalCall();
			}
    }
}
</script>
